import { attributesStyles } from "@WhiteCap/Widgets/ProductDetailsPage/ProductDetailsSpecification";
import { css } from "styled-components";

attributesStyles.specificationTittle = {
    css: css`
        border-bottom: 0.2rem solid #fc3;
        box-sizing: border-box;
        display: inline-flex;
        font-weight: 500;
        color: #474747;
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 20px;
        padding-top: 10px;
    `,
};
